import React from 'react';
import { useSession } from '../context/SessionContext';

interface RoleBasedAccessProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

const internalRoles = ['Admin', 'Support', 'Auditor', 'Billing'];

export const userHasAccess = (userRole: string | null | undefined, allowedRoles: string[]): boolean => {
  if (!userRole) return false;

  const expandedRoles = allowedRoles.includes('Internal')
    ? [...allowedRoles.filter(role => role !== 'Internal'), ...internalRoles]
    : allowedRoles;

  return expandedRoles.includes(userRole);
};

const RoleBasedAccess: React.FC<RoleBasedAccessProps> = ({ allowedRoles, children }) => {
  const { user } = useSession();
  const hasAccess = userHasAccess(user?.role, allowedRoles);

  if (!hasAccess) return null;

  return <>{children}</>;
};

export default RoleBasedAccess;
